import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router';

import { ErrorRoutes, maintenanceRoutes } from '@speechki-frontend/core/misc/routes';
import AuthRoutes from '@speechki-frontend/core/auth/routes';
import CustomersRoutes from '@/customers/routes';
import EmployeesRoutes from '@/employees/routes';
import OrdersRoutes from '@/orders/routes';
import UsersRoutes from '@/users/routes';
import TokensRoutes from '@/tokens/routes';
import TransitionsRoutes from '@/transitions/routes';
import NotificationsRoutes from '@/notifications/routes';
import FlowsRoutes from '@/flows/routes';

const { VUE_APP_ROUTER_BASEURL = '/', VUE_APP_IS_REVIEW = false } = process.env;
const postTitle = 'Speechki';
const history =
    VUE_APP_IS_REVIEW === 'true'
        ? createWebHashHistory(VUE_APP_ROUTER_BASEURL)
        : createWebHistory(VUE_APP_ROUTER_BASEURL);

let routes = [
    ...ErrorRoutes,
    ...AuthRoutes,
    ...CustomersRoutes,
    ...EmployeesRoutes,
    ...OrdersRoutes,
    ...UsersRoutes,
    ...TokensRoutes,
    ...TransitionsRoutes,
    ...NotificationsRoutes,
    ...FlowsRoutes,
    {
        ...OrdersRoutes[0],
        name: 'home',
        path: '/',
    },
];

if (process.env.VUE_APP_MAINTENANCE) {
    routes = maintenanceRoutes;
}

const router = createRouter({
    history,
    routes,
});

router.beforeEach((to, from, next) => {
    const token = localStorage.getItem('token');

    if (to.meta.guest) {
        if (token && to.path === '/login') {
            next('/orders');
        }

        next();
    } else {
        if (!token) {
            next('/login');
        }

        next();
    }
});

router.afterEach((to) => {
    if (to.fullPath !== '/login' && !to.fullPath.startsWith('/invite')) {
        localStorage.setItem('lastroute', to.fullPath);
    }

    document.title = to.meta && to.meta.title ? to.meta.title + ' — ' + postTitle : postTitle;
});
export default router;
